import React, { useContext } from "react";
import styles from "./WarningPanel.module.css";
import { DialogContext } from "../../context/DialogContext";
import { QuestionStatus } from "../../util/QuestionStatus";
import CustomButton, { ButtonType } from "../button/CustomButton";
import { DialogShownFromType } from "./Dialog";
import { KowledgeContentBulkUpdateStatus } from "../../api/KnowledgeContentApiCall";
import { useAppDispatch } from "../../store/common/hooks";
import { fetchConversations } from "../../store/conversations.slice";
import { setCallApproveApi } from "../../store/context.slice";

interface WarningPanelProps {
  id: number;
  question: string;
  answer: string;
  setSwapped: (value: boolean) => void;
  dialogShownFromType: DialogShownFromType;
}

const WarningPanel: React.FC<WarningPanelProps> = ({
  id,
  question,
  answer,
  setSwapped,
  dialogShownFromType,
}) => {
  const { dismissDialog } = useContext(DialogContext);
  const dispatch = useAppDispatch();

  const handleConfirm = async () => {
    if (dialogShownFromType == DialogShownFromType.NeedApproval) {
      await KowledgeContentBulkUpdateStatus([id], QuestionStatus.Approved);
      setSwapped(false);
      dispatch(fetchConversations());
    } else {
      dispatch(setCallApproveApi({ isSelected: true }));
    }
    dismissDialog();
  };

  return (
    <>
      <div className={styles.warningBox}>
        <div className={styles.warningInner}>
          <div className={styles.warningTitle}>
            {dialogShownFromType == DialogShownFromType.NeedApproval
              ? "This New FAQ Will directly write into the brain."
              : "This New FAQ Will directly write into the Need Approval."}
          </div>
          <div className={styles.warningText}>
            Please check similarities of other FAQs below
          </div>
          <div className={styles.questionAns}>{`Question: ${question}`}</div>
          <div className={styles.questionAns}>{`Answer: ${answer}`}</div>
          <div className={styles.warningActions}>
            <button onClick={() => setSwapped(false)} className={styles.cancel}>
              Cancel
            </button>
            <CustomButton
              type={ButtonType.Approve}
              onClick={handleConfirm}
              text={
                dialogShownFromType == DialogShownFromType.NeedApproval
                  ? "Add to Brain"
                  : "Add to Need Approval"
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default WarningPanel;
